/* BIO Circle Menu v6.5 - vanilla, defer, cero librerias.
   v6.5: click "thock" seco (golpe grave + snap de ruido; nada agudo).
   v6.4: + "click" UI al tocar elementos del menu (mismo interruptor de sonido;
   el whoosh de apertura queda igual).
   v6.3: + sonido "shhh" al abrir (whoosh suave generado con Web Audio API:
   ruido filtrado con sweep, ~0.45s, volumen bajo; cero archivos de audio).
   Suena SOLO en el gesto del usuario (permitido por autoplay policies) y se
   apaga con el setting de la seccion (data-bio-cm-sound="false").
   v6.2: clip-path circle() + Web Animations API (expansion circular real),
   singleton global, portal a <body>, captura del boton nativo del header. */
(function () {
  'use strict';
  var OPEN_MS = 520;
  var CLOSE_MS = 380;
  function playWhoosh() {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      if (!window.__bioCmAC) { window.__bioCmAC = new Ctx(); }
      var ac = window.__bioCmAC;
      if (ac.state === 'suspended') { ac.resume(); }
      var dur = 0.45;
      var sr = ac.sampleRate;
      var buf = ac.createBuffer(1, Math.floor(sr * dur), sr);
      var d = buf.getChannelData(0);
      for (var i = 0; i < d.length; i++) { d[i] = Math.random() * 2 - 1; }
      var src = ac.createBufferSource();
      src.buffer = buf;
      var f = ac.createBiquadFilter();
      f.type = 'bandpass';
      f.Q.value = 0.9;
      f.frequency.setValueAtTime(280, ac.currentTime);
      f.frequency.exponentialRampToValueAtTime(2200, ac.currentTime + dur * 0.8);
      var g = ac.createGain();
      g.gain.setValueAtTime(0.0001, ac.currentTime);
      g.gain.exponentialRampToValueAtTime(0.11, ac.currentTime + 0.07);
      g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur);
      src.connect(f); f.connect(g); g.connect(ac.destination);
      src.start();
      src.stop(ac.currentTime + dur);
    } catch (e) {}
  }
  function playClick() {
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      if (!window.__bioCmAC) { window.__bioCmAC = new Ctx(); }
      var ac = window.__bioCmAC;
      if (ac.state === 'suspended') { ac.resume(); }
      var t = ac.currentTime;
      var o = ac.createOscillator();
      o.type = 'sine';
      o.frequency.setValueAtTime(190, t);
      o.frequency.exponentialRampToValueAtTime(68, t + 0.06);
      var g = ac.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.5, t + 0.004);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.075);
      o.connect(g); g.connect(ac.destination);
      o.start(t);
      o.stop(t + 0.09);
      var dur = 0.016;
      var buf = ac.createBuffer(1, Math.floor(ac.sampleRate * dur), ac.sampleRate);
      var d = buf.getChannelData(0);
      for (var i = 0; i < d.length; i++) { d[i] = (Math.random() * 2 - 1) * (1 - i / d.length); }
      var n = ac.createBufferSource();
      n.buffer = buf;
      var f = ac.createBiquadFilter();
      f.type = 'lowpass';
      f.frequency.value = 2400;
      var g2 = ac.createGain();
      g2.gain.value = 0.16;
      n.connect(f); f.connect(g2); g2.connect(ac.destination);
      n.start(t);
    } catch (e) {}
  }
  function init(root) {
    if (root.dataset.bioCmInit === '1') return;
    root.dataset.bioCmInit = '1';
    if (window.__bioCmCleanup) { try { window.__bioCmCleanup(); } catch (e) {} }
    var overlay = root.querySelector('[data-bio-cm-overlay]');
    var fallback = root.querySelector('[data-bio-cm-trigger]');
    if (!overlay) return;
    var circle = overlay.querySelector('[data-bio-cm-circle]');
    var veil = overlay.querySelector('[data-bio-cm-veil]');
    var panel = overlay.querySelector('[data-bio-cm-panel]');
    var closeBtn = overlay.querySelector('[data-bio-cm-close]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var sonido = root.getAttribute('data-bio-cm-sound') !== 'false';
    var supportsWaapi = typeof overlay.animate === 'function';
    var supportsClip = (typeof CSS !== 'undefined' && CSS.supports && (CSS.supports('clip-path', 'circle(1px at 0 0)') || CSS.supports('-webkit-clip-path', 'circle(1px at 0 0)')));
    var sel = root.getAttribute('data-bio-cm-native-selector') || 'header-drawer summary';
    var native = null;
    try { native = document.querySelector(sel); } catch (err) { native = null; }
    var trigger = native || fallback;
    if (!trigger) return;
    if (!native && fallback) { fallback.hidden = false; }

    var bg = '#0b0b0e';
    if (circle && circle.style.backgroundColor) { bg = circle.style.backgroundColor; }

    document.body.appendChild(overlay);
    var os = overlay.style;
    os.position = 'fixed'; os.top = '0'; os.right = '0'; os.bottom = '0'; os.left = '0';
    os.zIndex = '2147482000';
    os.backgroundColor = bg;
    if (circle) { circle.style.display = 'none'; }
    if (veil) { veil.style.display = 'none'; }
    if (panel) {
      var ps = panel.style;
      ps.position = 'absolute'; ps.top = '0'; ps.right = '0'; ps.bottom = '0'; ps.left = '0';
      ps.width = '100%'; ps.height = '100%';
      ps.zIndex = '1'; ps.overflowY = 'auto'; ps.opacity = '0';
    }
    var isOpen = false, bodyOverflow = '', hideTimer = null;
    var animOverlay = null, animPanel = null;
    function cancelAnims() {
      if (animOverlay) { try { animOverlay.cancel(); } catch (e) {} animOverlay = null; }
      if (animPanel) { try { animPanel.cancel(); } catch (e) {} animPanel = null; }
    }
    function focusables() {
      return overlay.querySelectorAll('a[href], button:not([disabled])');
    }
    function setExpanded(v) {
      trigger.setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    function origin() {
      var r = trigger.getBoundingClientRect();
      if (!r || r.width === 0) { return { x: 32, y: 32 }; }
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    function open() {
      try {
        if (isOpen) return;
        isOpen = true;
        window.clearTimeout(hideTimer);
        cancelAnims();
        overlay.hidden = false;
        os.display = 'block';
        bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        setExpanded(true);
        if (sonido && !reduce.matches) { playWhoosh(); }
        var anima = supportsWaapi && supportsClip && !reduce.matches;
        var o = origin();
        if (anima) {
          var dx = Math.max(o.x, window.innerWidth - o.x);
          var dy = Math.max(o.y, window.innerHeight - o.y);
          var maxR = Math.ceil(Math.hypot(dx, dy)) + 32;
          os.opacity = '1';
          animOverlay = overlay.animate(
            [
              { clipPath: 'circle(24px at ' + o.x + 'px ' + o.y + 'px)' },
              { clipPath: 'circle(' + maxR + 'px at ' + o.x + 'px ' + o.y + 'px)' }
            ],
            { duration: OPEN_MS, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' }
          );
        } else if (supportsWaapi && !reduce.matches) {
          animOverlay = overlay.animate(
            [ { opacity: 0 }, { opacity: 1 } ],
            { duration: 200, easing: 'ease', fill: 'forwards' }
          );
        } else {
          os.opacity = '1';
        }
        if (panel) {
          if (supportsWaapi && !reduce.matches) {
            animPanel = panel.animate(
              [ { opacity: 0 }, { opacity: 1 } ],
              { duration: 240, delay: 200, easing: 'ease', fill: 'forwards' }
            );
          } else {
            panel.style.opacity = '1';
          }
        }
        var f = focusables();
        if (f.length) f[0].focus();
      } catch (err) { window.__bioCmLastError = 'open: ' + String(err); }
    }
    function close() {
      try {
        if (!isOpen) return;
        isOpen = false;
        setExpanded(false);
        cancelAnims();
        var anima = supportsWaapi && supportsClip && !reduce.matches;
        var o = origin();
        if (anima) {
          var dx = Math.max(o.x, window.innerWidth - o.x);
          var dy = Math.max(o.y, window.innerHeight - o.y);
          var maxR = Math.ceil(Math.hypot(dx, dy)) + 32;
          animOverlay = overlay.animate(
            [
              { clipPath: 'circle(' + maxR + 'px at ' + o.x + 'px ' + o.y + 'px)' },
              { clipPath: 'circle(18px at ' + o.x + 'px ' + o.y + 'px)' }
            ],
            { duration: CLOSE_MS, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' }
          );
        } else if (supportsWaapi && !reduce.matches) {
          animOverlay = overlay.animate(
            [ { opacity: 1 }, { opacity: 0 } ],
            { duration: 150, easing: 'ease', fill: 'forwards' }
          );
        }
        if (panel) {
          if (supportsWaapi && !reduce.matches) {
            animPanel = panel.animate(
              [ { opacity: 1 }, { opacity: 0 } ],
              { duration: 100, easing: 'ease', fill: 'forwards' }
            );
          } else {
            panel.style.opacity = '0';
          }
        }
        document.body.style.overflow = bodyOverflow;
        hideTimer = window.setTimeout(function () {
          overlay.hidden = true;
          os.display = 'none';
          cancelAnims();
          if (panel) { panel.style.opacity = '0'; }
        }, reduce.matches ? 30 : CLOSE_MS + 40);
        if (trigger.focus) { trigger.focus(); }
      } catch (err) { window.__bioCmLastError = 'close: ' + String(err); }
    }
    function toggle() { if (isOpen) { close(); } else { open(); } }
    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    window.__bioCmSel = sel;
    window.__bioCmToggle = toggle;
    window.__bioCmCleanup = function () {
      window.clearTimeout(hideTimer);
      document.body.style.overflow = '';
      if (overlay && overlay.parentElement) { overlay.parentElement.removeChild(overlay); }
      window.__bioCmToggle = null;
    };

    if (native) {
      native.setAttribute('aria-haspopup', 'dialog');
      setExpanded(false);
      if (!window.__bioCmClickBound) {
        window.__bioCmClickBound = true;
        document.addEventListener('click', function (e) {
          if (!e.target || !e.target.closest) return;
          var t = e.target.closest(window.__bioCmSel || 'header-drawer summary');
          if (!t) return;
          e.preventDefault();
          e.stopPropagation();
          if (window.__bioCmToggle) { window.__bioCmToggle(); }
        }, true);
      }
    } else if (fallback) {
      fallback.addEventListener('click', toggle);
    }
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('keydown', onKeydown);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === panel) close();
    });
    overlay.addEventListener('click', function (e) {
      if (!sonido || reduce.matches) return;
      if (!e.target || !e.target.closest) return;
      var el = e.target.closest('a, button');
      if (!el || !overlay.contains(el)) return;
      playClick();
    });
  }
  function boot() {
    document.querySelectorAll('[data-bio-circle-menu]').forEach(function (el) { init(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
